export default {
    SET_ALL_RATE_TABLES(state, {rateTables, total, per_page}) {
        state.rateTables = rateTables,
        state.totalPage = total / per_page;
        state.totalItems = total;
    },

    EDIT_RATE_TABLE(state, rateTable) {
        state.rateTables = state.rateTables.map(item => {
            if(state.rate_table_uuid === rateTable.rate_table_uuid) {
                return rateTable;
            }
            return item;
        })
    },

    REMOVE_RATE_TABLE(state, rate_table_uuid) {
        state.rateTables = state.rateTables.filter(rateTable => rateTable.rate_table_uuid !== rate_table_uuid);
    },

    SET_RATE_TABLE(state, rateTable) {
        state.rateTable = rateTable;
    },

    UPDATE_RATE(state, fields) {
        if(Object.keys(fields).length === 0) {
            state.rate = {};
            return
        }
        if(fields.hasOwnProperty('code')){
            //delete state.rateTable.rates[state.activeRateId].mobile_network_uuid

        }


        let copyRate = { ...state.rateTable.rates[state.activeRateId] };
        // state.rateTable.rates[state.activeRateId] = { ...copyRate, ...fields };
        state.rateTable.rates.splice(state.activeRateId, 1, { ...copyRate, ...fields });
    },

    ADD_RATE(state, rate) {
        state.rateTable.rates.push(rate);
        state.activeRateId = state.rateTable.rates.length - 1;
    },

    UPDATE_RATES(state, rate) {console.log('update',rate);
        state.rateTable.rates = state.rateTable.rates.map((item, index) => {
            if(index === state.activeRateId) {
                return rate;
            }
            return item;
        })
    },

    REMOVE_RATE(state, i) {
        state.rateTable.rates.splice(i, 1);
    },

    UPDATE_ACTIVE_RATE_ID(state, id) {
        state.activeRateId = id;
    }


}